<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Modifier un espace</strong>
          </div>
          <b-form>
            <b-form-group label="Nom" label-for="basicName">
              <b-form-input
                id="basicName"
                type="text"
                autocomplete="name"
                :class="{hasError: errors.nom !== ''}"
                v-model="nom"
              />
              <span class="field-error">{{ errors.nom }}</span>
            </b-form-group>
            <b-form-group label="Ordre" label-for="ordre">
              <b-form-input
                id="ordre"
                type="number"
                :class="{hasError: errors.ordre !== ''}"
                v-model="ordre"
              />
              <span class="field-error">{{ errors.ordre }}</span>
            </b-form-group>
            <b-form-group label="Description" label-for="description">
              <b-form-textarea
                id="description"
                type="text"
                :class="{hasError: errors.description !== ''}"
                rows="3"
                max-rows="6"
                v-model="description">
              </b-form-textarea>
            </b-form-group>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des espaces
              </b-button>
              <b-button type="button" @click="editEspace" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "EditEspace",
    data() {
      return {
        nom: "",
        ordre: 0,
        description: "",
        errors: {
          nom: "",
          ordre: "",
          description: "",
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getEspace();
    },
    methods: {
      getEspace() {
        this.$store.commit('IS_LOADING', true)
        let id = this.$route.params.id;
        let self = this;

        this.$axios
          .get("/administration/espaces/" + id)
          .then(response => {
            this.id = response.data.espace.id;
            this.nom = response.data.espace.nom;
            this.ordre = response.data.espace.ordre;
            this.description = response.data.espace.description;
            this.$store.commit('IS_LOADING', false)
          })
          .catch((error) => {
            this.$store.commit('IS_LOADING', false)
            if (error.response && error.response.status === 404 && self != undefined) {
              this.$swal({
                position: 'top',
                type: 'warning',
                title: 'Attention !!',
                text: `L'espace avec l'id ${id} n'existe pas`,
                showConfirmButton: false,
                timer: 5000
              });
              this.$router.push({path: '/administration/espaces'})
            }
          });
      },
      editEspace() {
        if (this.validateData()) {
          let id = this.$route.params.id;
          this.$store.commit("IS_LOADING", true);
          let self = this;
          let dataPost = {};
          dataPost.nom = this.nom;
          dataPost.ordre = this.ordre;
          dataPost.description = this.description;
          this.$axios
            .put("/administration/espaces/"+id, dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Modification avec succès",
                text: "L'espace a été bien modifié ",
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack()
            })
            .catch((error) => {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: error,
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/administration/espaces"});
      },
      validateData() {
        this.clearErrors()
        let regAlpha = this.$store.getters.getRegAlpha
        let valid = true

        if (this.nom === "") {
          this.errors.nom = "Le nom est obligatoire";
          valid = false;
        } else if (!regAlpha.test(this.nom)) {
          valid = false
          this.errors.nom = 'Veuillez saisir un nom valide'
        }
        return valid;
      },
      clearErrors() {
        this.errors.nom = "";
        this.errors.ordre = "";
        this.errors.description = "";
      }
    }
  }
</script>
